<div class="diagram-container">
	<div class="diagram">
		<img class="image" [src]="'diagram.png'">
		<div *ngFor="let item of data">
			<div class="circle" [ngClass]="{'active': item.isActive}"
				 *ngIf="item.position  && item.position.left && item.position.top"
				 [ngStyle]="{'position': 'absolute', 'top': (item.position.top - getRadius(item)) +'px',
							 'left': (item.position.left - getRadius(item)) +'px'}"
				 [title]="item.description"
				 (click)="onSelect(item)">
				<div *ngIf="!item.isActive" class="insert-circle"></div>
			</div>
		</div>

		<span class="directions">
			<label>R</label>
			<label>L</label>
		</span>
	</div>
</div>
